import React from "react";
import "./stepTwo.scss";

// Imagens:
import ImgStepTwo from "../../../../assets/homeImgs/stepTwo.png";
import { useTranslation } from "react-i18next";

const StepTwo = () => {
  const {t} = useTranslation()

  return (
    <div className="container-step-two">

      <div className="img-step-two">
        <img src={ImgStepTwo} alt="imagem step um" />
      </div>
      <div className="texts-step-two">
        <h1>2. {t("home.step2.title")}</h1>
        <p>{t("home.step2.section_text")}</p>
        {/* <button id="btn-step-two">CONFIRA!</button> */}
      </div>
    </div>
  );
};
export default StepTwo;
